import React, { FunctionComponent, memo } from "react";
import { Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import InvestorRequestFormTitle from "@investorRequest/components/InvestorRequestFormTitle";
import PaymentMethodDescription from "@investorRequest/components/PaymentMethodDescription";
import { PaymentMethodKey, isPaymentMethodKey } from "@investorRequest/constants/paymentMethodDescriptions";

interface DisabledOptions {
  ach?: boolean;
  fedwire?: boolean;
  swift?: boolean;
}

interface Props {
  value: string;
  onChange(value: string): void;
  isInternalContext: boolean;
  disabledOptions?: DisabledOptions;
}

const PAYMENT_METHOD_OPTIONS: ReadonlyArray<{ key: PaymentMethodKey; label: string }> = [
  { key: "ach", label: "ACH" },
  { key: "fedwire", label: "Fed Wire" },
  { key: "swift", label: "Swift" },
];

const PaymentMethodSelector: FunctionComponent<Props> = ({ value, onChange, isInternalContext, disabledOptions }) => {
  const isDisabled = (method: PaymentMethodKey): boolean => !!disabledOptions?.[method];

  const handleSelect = (next: PaymentMethodKey) => {
    if (isDisabled(next)) return; // hard block clicks when disabled

    // No deselect behavior: keep selection stable; just set the chosen method
    if (value !== next) {
      onChange(next);
    }
  };

  return (
    <>
      <InvestorRequestFormTitle text="Payment Method:" />
      <Grid item xs={12}>
        <RadioGroup row value={value || ""} aria-label="payment-method" name="payment-method">
          {PAYMENT_METHOD_OPTIONS.map(({ key, label }) => (
            <FormControlLabel
              key={key}
              value={key}
              control={<Radio size="small" />}
              label={label}
              disabled={isDisabled(key)}
              onClick={() => handleSelect(key)}
            />
          ))}
        </RadioGroup>
      </Grid>
      {isPaymentMethodKey(value) && (
        <PaymentMethodDescription paymentMethod={value} isInternalContext={isInternalContext} />
      )}
    </>
  );
};

export default memo(PaymentMethodSelector);
